import React from "react";
import { Syringe, Droplet, Sparkles, Waves, Zap, Scan, ArrowUpRight } from "lucide-react";
import { services } from "../mock";
import useReveal from "../hooks/useReveal";
import { useContent } from "../context/ContentContext";

const iconMap = { Syringe, Droplet, Sparkles, Waves, Zap, Scan };

export default function Services() {
  const [ref, inView] = useReveal();
  const { content } = useContent();
  const servicesUrl = content.settings.servicesUrl;
  return (
    <section id="services" className="bg-[#0C0C0C] py-24 md:py-32 px-6">
      <div ref={ref} className={`max-w-6xl mx-auto reveal ${inView ? "in-view" : ""}`}>
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xs tracking-[0.25em] text-[#C6A15B] uppercase">/ 02</span>
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.25em] text-[#8A857A] uppercase">
            Pride in Each Service
          </span>
        </div>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#F7F2EA]">Our Services</h2>
          <a
            href={servicesUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#C6A15B] hover:gap-3 transition-all"
          >
            View All Services <ArrowUpRight size={16} />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Sparkles;
            return (
              <div
                key={s.title}
                className="service-card border border-[#252525] bg-[#111111] hover:border-[#C6A15B]/60 hover:bg-[#141414] p-8"
              >
                <div className="h-12 w-12 rounded-full border border-[#C6A15B]/40 flex items-center justify-center text-[#C6A15B] mb-6">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="font-serif-display text-2xl text-[#F7F2EA] mb-3">{s.title}</h3>
                <p className="text-sm text-[#9E988B] leading-relaxed font-light">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
